import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spin, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';

import Cookies from 'js-cookie';

// Images
import ecosystemImage from '../../assets/images/ecosystem1.png';
import indicatorImage from '../../assets/images/indicator1.png';
import indicatorImage2 from '../../assets/images/indicator2.png';
import specieImage1 from '../../assets/images/species1.png';
import specieImage2 from '../../assets/images/species2.png';
import specieImage4 from '../../assets/images/species4.png';
import habitatImage1 from '../../assets/images/habitat1.png';
import habitatImage3 from '../../assets/images/habitat3.png';
import mapCyprusImage from '../../assets/images/map_cyprus.png';
import mapGreeceImage from '../../assets/images/map_greece.png';
import greekCaseStudyImage from '../../assets/images/greekCaseStudy.png';
import { CaseStudyKey } from '../../interfaces';

const { Title, Text } = Typography;

const Home: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [selectedCaseStudy, setSelectedCaseStudy] = useState<string | null>(null);
  const HOME_PAGE_IMAGES: Record<
    CaseStudyKey,
    {
      title: string;
      species: string;
      habitat: string;
      ecosystem: string | null;
      indicator: string;
      landscape: string | null;
      learnMoreUrl: string;
    }
  > = {
    cyprus: {
      title: 'Consideration of species loss caused by expansion of energy centre-CY',
      species: specieImage1,
      habitat: habitatImage1,
      ecosystem: ecosystemImage,
      indicator: indicatorImage,
      landscape: mapCyprusImage,
      learnMoreUrl: 'https://guarden.org/guarden-case-studies/cyprus-case-study/',
    },
    greece: {
      title: 'Structured framework for post construction ecosystem monitoring of windfarms-GR',
      species: specieImage2,
      habitat: habitatImage1,
      ecosystem: ecosystemImage,
      indicator: indicatorImage,
      landscape: mapGreeceImage,
      learnMoreUrl: 'https://guarden.org/guarden-case-studies/greece-case-study/',
    },
    barcelona: {
      title: 'Biodiversity vs Urban Coastal Management-SP',
      species: specieImage4,
      habitat: habitatImage3,
      ecosystem: null,
      indicator: indicatorImage2,
      landscape: null,
      learnMoreUrl: 'https://guarden.org/guarden-case-studies/spain-case-study/',
    },
    pnr_narbonnaise: {
      title: 'Conservation vs development of urban and transport infrastructures-FR/MD',
      species: specieImage1,
      habitat: habitatImage1,
      ecosystem: ecosystemImage,
      indicator: indicatorImage,
      landscape: null,
      learnMoreUrl: 'https://guarden.org/guarden-case-studies/france-and-madagascar-case-study/',
    },
  };

  useEffect(() => {
    const checkForCaseStudyCookie = () => {
      const cookieValue = Cookies.get('caseStudy');
      if (cookieValue) {
        setSelectedCaseStudy(cookieValue);
        setLoading(false);
      } else {
        setTimeout(checkForCaseStudyCookie, 100);
      }
    };
    checkForCaseStudyCookie();
    return () => { };
  }, []);

  if (loading || !selectedCaseStudy) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <Spin size='large' />
        <p>Loading case study...</p>
      </div>
    );
  }

  const caseStudyImages = HOME_PAGE_IMAGES[selectedCaseStudy as CaseStudyKey];

  const renderCard = (title: string, imageUrl: string, link: string) => (
    <Col span={12} style={{ padding: 10 }}>
      <Link to={link}>
        <Card
          style={{
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${imageUrl})`,
            backgroundPosition: 'center',
            height: 350,
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: 'white',
            textShadow: `
              -1px -1px 0 black,
              1px -1px 0 black,
              -1px  1px 0 black,
              1px  1px 0 black
            `,
          }}
          hoverable
        >
          <h1 style={{ color: 'white', fontWeight: 700, fontSize: '2rem' }}>{title}</h1>
        </Card>
      </Link>
    </Col>
  );

  return (
    <div>
      <Title level={1} style={{ textAlign: 'center', marginBottom: '8px', color: '#329619' }}>
        {caseStudyImages.title}
      </Title>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <Button
          type="primary"
          href={caseStudyImages.learnMoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ backgroundColor: '#329619', borderColor: '#329619' }}
        >
          Learn more about this case study
        </Button>
      </div>
      <Text type='secondary' style={{ display: 'block', textAlign: 'center', fontSize: '16px', marginBottom: '20px' }}>
        Please note that this tool is not intended to replace an impact study and does not hold any legal value.
      </Text>
      <Row gutter={16} id='menuSelectId'>
        {renderCard('Species', caseStudyImages.species, '/species/observations')}
        {renderCard('Habitats', caseStudyImages.habitat, '/habitat')}
        {renderCard('Indicators', caseStudyImages.indicator, '/indicators/conservation')}
        {selectedCaseStudy === 'cyprus' &&
          renderCard('Bird Acoustic Monitoring', greekCaseStudyImage, '/species/acoustic')}
        {selectedCaseStudy === 'greece' &&
          renderCard('Bird Acoustic Monitoring', greekCaseStudyImage, '/greekCaseStudy/spatialAnalysis')}
        {caseStudyImages.ecosystem && renderCard('Ecosystem', caseStudyImages.ecosystem, '/ecosystem')}
        {caseStudyImages.landscape &&
          renderCard('Landscape', caseStudyImages.landscape, '/landscape/land-use_land-cover')}
      </Row>
    </div>
  );
};

export default Home;